import React from "react";
import { Stack } from "@mui/material";
import XpverseLogo from "../../images/logo.png";

function Logo() {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ width: { xs: "90px", lg: "115px" }, height: "80px" }}
    >
      <img src={XpverseLogo} style={{ width: "100%" }} alt="logo" />
    </Stack>
  );
}

export default Logo;
